/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowDefinitionsBase {
    getFixupPrototypeFunction() { return WorkFlowDefinitionsBase.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowDefinitionsBase>): WorkFlowDefinitionsBase {
        let obj = Object.assign(new WorkFlowDefinitionsBase(), model);
        WorkFlowDefinitionsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowDefinitionsBase>): WorkFlowDefinitionsBase {
        if (!model) return null;
        return WorkFlowDefinitionsBase.newInstance(<WorkFlowDefinitionsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowDefinitionsBase) {
        if (!obj) return;

        models.WorkFlowDefinitionsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowDefinitionsBase): boolean {
        Object.setPrototypeOf(obj, WorkFlowDefinitionsBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_on === "string") {
            this.created_on = new Date(<string><any>this.created_on);
        }
        if (typeof this.updated_on === "string") {
            this.updated_on = new Date(<string><any>this.updated_on);
        }
    }

    /**
     * Name for the workflow.
     */
    name: string;

    /**
     * Module for which the workflow which has to be generated.
     */
    module: models.WorkFlowModules;

    /**
     * Boolean represents whether the workflow is active or not
     */
    is_active: boolean = true;

    /**
     * Sys Id of the master account where the workflow belongs to
     */
    tenant_id: string;

    /**
     * SubCategory for which the workflow which has to be generated.
     */
    category: models.WorkFlowCategory;

    /**
     * Unique Sys Id for a workflow
     */
    workflow_id: string;

    /**
     * Created time for the workflow.
     */
    created_on: Date;

    /**
     * Last Updated time for the workflow.
     */
    updated_on: Date;

    /**
     * User who created the workflow
     */
    created_by: string;

    /**
     * User who last updated the workflow
     */
    updated_by: string;

}
